import { combineReducers } from 'redux';

import { activeId } from './activeId';
import { byId } from './byId';

export const reducer = combineReducers({
  activeId,
  byId
});
